
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import EisenhowerQuadrantColumn from './EisenhowerQuadrantColumn';
import { Task } from '@/context/TaskContext';

interface Quadrant {
  id: string;
  label: string;
  icon: string;
}
interface EisenhowerQuadrantGridProps {
  quadrants: Quadrant[];
  quadrantTasks: { [key: string]: Task[] };
}

const EisenhowerQuadrantGrid: React.FC<EisenhowerQuadrantGridProps> = ({
  quadrants, quadrantTasks,
}) => (
  <div className="grid grid-cols-[2rem_1fr_1fr] grid-rows-[auto_1fr_1fr] gap-4 h-full">
    {/* Empty top-left corner */}
    <div></div>
    
    {/* Urgent label */}
    <div className="flex justify-center items-center text-xs text-foreground min-h-[2rem]">
      <span className="text-sm font-medium">Urgent</span>
    </div>
    
    {/* Not urgent label */}
    <div className="flex justify-center items-center text-xs text-foreground min-h-[2rem]">
      <span className="text-sm font-medium">Not urgent</span>
    </div>

    {/* Important label */}
    <div className="flex justify-center items-center text-xs text-foreground min-w-[0.5rem]">
      <span className="text-sm font-medium -rotate-90 whitespace-nowrap">Important</span>
    </div>

    {/* Do First quadrant */}
    <Droppable
      key={quadrants[0].id}
      droppableId={`quadrant-${quadrants[0].id}`}
      direction="vertical"
    >
      {(provided) => (
        <EisenhowerQuadrantColumn
          id={quadrants[0].id}
          label={quadrants[0].label}
          icon={quadrants[0].icon}
          tasks={quadrantTasks[quadrants[0].id]}
          provided={provided}
          innerRef={provided.innerRef}
          handleDragStart={() => {}}
        />
      )}
    </Droppable>

    {/* Schedule quadrant */}
    <Droppable
      key={quadrants[1].id}
      droppableId={`quadrant-${quadrants[1].id}`}
      direction="vertical"
    >
      {(provided) => (
        <EisenhowerQuadrantColumn
          id={quadrants[1].id}
          label={quadrants[1].label}
          icon={quadrants[1].icon}
          tasks={quadrantTasks[quadrants[1].id]}
          provided={provided}
          innerRef={provided.innerRef}
          handleDragStart={() => {}}
        />
      )}
    </Droppable>

    {/* Not important label */}
    <div className="flex justify-center items-center text-xs text-foreground min-w-[0.5rem]">
      <span className="text-sm font-medium -rotate-90 whitespace-nowrap">Not important</span>
    </div>

    {/* Delegate quadrant */}
    <Droppable
      key={quadrants[2].id}
      droppableId={`quadrant-${quadrants[2].id}`}
      direction="vertical"
    >
      {(provided) => (
        <EisenhowerQuadrantColumn
          id={quadrants[2].id}
          label={quadrants[2].label}
          icon={quadrants[2].icon}
          tasks={quadrantTasks[quadrants[2].id]}
          provided={provided}
          innerRef={provided.innerRef}
          handleDragStart={() => {}}
        />
      )}
    </Droppable>

    {/* Eliminate quadrant */}
    <Droppable
      key={quadrants[3].id}
      droppableId={`quadrant-${quadrants[3].id}`}
      direction="vertical"
    >
      {(provided) => (
        <EisenhowerQuadrantColumn
          id={quadrants[3].id}
          label={quadrants[3].label}
          icon={quadrants[3].icon}
          tasks={quadrantTasks[quadrants[3].id]}
          provided={provided}
          innerRef={provided.innerRef}
          handleDragStart={() => {}}
        />
      )}
    </Droppable>
  </div>
);

export default EisenhowerQuadrantGrid;
